import { useParams } from 'react-router-dom';
import { blogs } from '../../data/blog';
import Header from '../common/Header';
import Footer from '../common/Footer';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

export default function BlogDetails() {
  const { slug } = useParams();
  const blog = blogs.find((b) => b.slug === slug);
  const [headings, setHeadings] = useState([]);
  const [contentWithIds, setContentWithIds] = useState('');

  useEffect(() => {
    if (blog) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(blog.content, 'text/html');
      const hElements = doc.querySelectorAll(' h2');

      const toc = [];
      hElements.forEach((h) => {
        const id = h.textContent
          .toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^\w-]/g, '');
        h.id = id;
        toc.push({ text: h.textContent, id, tag: h.tagName.toLowerCase() });
      });

      setHeadings(toc);
      setContentWithIds(doc.body.innerHTML);
    }
  }, [blog]);

  if (!blog) {
    return <h2 className='text-center mt-10'>Blog not found</h2>;
  }

  return (
    <div className='main-wrapper'>
      <Helmet>
        <title>{blog.metatitle}</title>
        <meta name='description' content={blog.metadescription} />

        <link rel='canonical' href={`https://swakaaya.com/blog/${blog.slug}`} />

        <meta property='og:title' content={blog.metatitle} />
        <meta property='og:description' content={blog.metadescription} />
        <meta
          property='og:url'
          content={`https://swakaaya.com/blog/${blog.slug}`}
        />
        <meta property='og:type' content='website' />
        <meta
          property='og:image'
          content='https://swakaaya.com/assets/images/logo.png'
        />
      </Helmet>
      <Header />
      <div style={{ marginTop: '120px', padding: '20px 50px' }}>
        <div className='row'>
          {/* Blog Content */}
          <div className='col-lg-7'>
            <h1 className='mb-3'>{blog.title}</h1>
            <p className='text-muted mb-4'>
              {new Date(blog.date).toDateString()}
            </p>

            <img
              src={blog.image}
              alt={blog.title}
              className='img-fluid rounded mb-4'
            />

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px', // gap between paragraphs, headings, lists, etc.
                lineHeight: '1.8',
              }}
              className='blog-content'
              dangerouslySetInnerHTML={{ __html: contentWithIds }}
            />
          </div>

          <div className='col-lg-1'></div>

          {/* Table of Contents */}
          {/* Table of Contents */}
          {headings.length > 0 && (
            <div className='col-lg-4 d-none d-lg-block'>
              <div
                style={{
                  position: 'sticky',
                  top: '120px', // distance from top of viewport
                  alignSelf: 'flex-start', // ensures it sticks at the top
                  padding: '20px',
                  backgroundColor: '#f9f1e7',
                  borderLeft: '5px solid #d8b36b',
                  borderRadius: '8px',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                }}
              >
                <h5 className='mb-4 fw-bold' style={{ color: '#8c6a36' }}>
                  Table of Contents
                </h5>
                <ul className='list-unstyled'>
                  {headings.map((h, index) => (
                    <li
                      key={index}
                      className={h.tag === 'h2' ? 'ms-3 mb-2' : 'mb-2'}
                    >
                      <a
                        href={`#${h.id}`}
                        className='text-decoration-none fw-medium'
                        style={{ color: '#6b4f1a', transition: 'all 0.2s' }}
                        onMouseEnter={(e) => (e.target.style.color = '#000')}
                        onMouseLeave={(e) => (e.target.style.color = '#6b4f1a')}
                        onClick={(e) => {
                          e.preventDefault(); // Prevent default anchor behavior
                          const target = document.getElementById(h.id);
                          if (target) {
                            target.scrollIntoView({ behavior: 'smooth' }); // Smooth scroll to the target
                          }
                        }}
                      >
                        {h.text}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
